module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-27-min.61c0102d.jpg";